import { type ArtBoardMode, artBoardActions } from '@store/reducers/artboard'
import { seoPanelHide } from '@storeOld/reducers/ui'
import { useDispatch } from 'react-redux'

import { useArtboardMode } from '@/hooks'

export const useSeoModeSwitcher = () => {
  const dispatch = useDispatch()
  const { seoMode } = useArtboardMode()

  const onClick = () => {
    const mode: ArtBoardMode = seoMode ? 'edit' : 'seo_mode'

    // Зум и позицию канваса не трогаем (OCT-4978): контейнер при смене режима
    // не перемонтируется, трансформа остаётся на нём и в sessionStorage таба.
    // Остальные входы в SEO-режим (SeoActions.enableMode) её и так не сбрасывают.
    dispatch(artBoardActions.changeMode(mode))
    dispatch(seoPanelHide())
  }

  return {
    active: seoMode,
    onClick,
  }
}
